import React from 'react';
import { Link } from 'react-router-dom';

const LegalFooter = () => {
  return (
    <div className="tw-row-start-12 tw-col-span-full">
      <div className="tw-border-t tw-border-solid tw-my-4 tw-pt-4 tw-flex tw-flex-wrap tw-gap-2 tw-w-full tw-justify-between tw-items-center">
        <div className="tw-text-xs">Jumble © 2025. All rights reserved.</div>
        <div>
          <Link to="/terms-and-privacy" aria-current="page" className="tw-text-xs tw-no-underline hover:tw-text-primary-900">
            Terms &amp; Privacy
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LegalFooter;
